import Enumerable from "linq";
import { DateTimeStringUtility } from "../../../../../../../base/domain/system";
import { INameHistorySpecifiable, IHistoryRecord, IObjectNameIdentifier } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";

export class NameHistoriesTranslator {
  from(bean: IXElementContentsObjectBean): IHistoryRecord<IObjectNameIdentifier>[] {
    return this.relationalItems.from(
      bean,
      is => Enumerable.from(is).select(i => ({
        value: {
          name: i["@name"],
          key: i["@key"],
          subKey: i["@subkey"],
        },
        recorded: i["@date"] ? DateTimeStringUtility.toDateValue(i["@date"]) : null,
      })).toArray(),
      []);
  }

  to(object: INameHistorySpecifiable): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(Enumerable.from(object.nameHistories).select(r => ({
      "@key": r.value.key,
      "@subkey": r.value.subKey,
      "@name": r.value.name,
      "@date": r.recorded ? DateTimeStringUtility.fromDateValue(r.recorded) : undefined,
    })).toArray());
  }

  private readonly relationalItems = new RelationTranslator("name-history");
}
